// extracted by mini-css-extract-plugin
export default {"sidebar":"style_sidebar__vQ7nA","hidden":"style_hidden__lMdLe","logo":"style_logo__8Z3M1","summary":"style_summary__VE7Md"};